import React, { memo } from 'react';
import { MapPinIcon, FootprintsIcon, CalendarIcon, MapIcon, MountainIcon } from 'lucide-react';
// Mock data
const adventureStats = {
  totalWalks: 286,
  totalDistance: 312,
  favoriteLocation: 'Sunset Park',
  longestWalk: '4.2 miles',
  mostActiveMonth: 'July'
};
const memorableWalks = [{
  id: 1,
  location: 'Beach Day',
  date: 'Jul 15',
  image: 'https://images.unsplash.com/photo-1530281700549-e82e7bf110d6?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80',
  highlight: 'First time swimming in the ocean!'
}, {
  id: 2,
  location: 'Mountain Trail',
  date: 'Sep 3',
  image: 'https://images.unsplash.com/photo-1588943211346-0908a1fb0b01?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80',
  highlight: 'Climbed to the summit lookout point'
}, {
  id: 3,
  location: 'Dog Park Friends',
  date: 'Oct 22',
  image: 'https://images.unsplash.com/photo-1556866261-8763a5b41192?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80',
  highlight: 'Made 3 new doggy friends!'
}];
interface WalksAdventuresProps {
  petName: string;
}
export const WalksAdventures = ({
  petName
}: WalksAdventuresProps) => {
  return <section className="rounded-2xl p-5 sm:p-8 bg-white shadow-[0_10px_60px_-15px_rgba(0,0,0,0.1)] relative overflow-hidden" data-id="element-110">
      <div className="absolute top-0 left-0 w-32 sm:w-40 h-32 sm:h-40 bg-green-100 rounded-full opacity-40 -ml-16 sm:-ml-20 -mt-16 sm:-mt-20" data-id="element-111"></div>
      <div className="absolute bottom-0 right-0 w-24 sm:w-32 h-24 sm:h-32 bg-green-100 rounded-full opacity-40 -mr-8 sm:-mr-10 -mb-8 sm:-mb-10" data-id="element-112"></div>
      <div className="flex items-center gap-3 sm:gap-4 mb-6 sm:mb-8 relative" data-id="element-113">
        <div className="bg-gradient-to-br from-green-400 to-green-600 p-2.5 sm:p-3 rounded-xl shadow-md" data-id="element-114">
          <MountainIcon className="w-5 h-5 sm:w-6 sm:h-6 text-white" data-id="element-115" />
        </div>
        <h2 className="text-xl sm:text-2xl font-bold text-gray-800" data-id="element-116">
          Walks & Adventures
        </h2>
      </div>
      <p className="text-gray-700 mb-6 sm:mb-8 text-base sm:text-lg max-w-2xl" data-id="element-117">
        You and {petName} explored so many places together!
      </p>
      {/* Stats */}
      <div className="bg-gradient-to-br from-white to-green-50 rounded-xl p-4 sm:p-6 shadow-md mb-8 sm:mb-10 relative overflow-hidden" data-id="element-118">
        <div className="absolute top-0 right-0 opacity-10" data-id="element-119">
          <FootprintsIcon className="w-24 sm:w-32 h-24 sm:h-32 text-green-500" data-id="element-120" />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6" data-id="element-121">
          <div className="text-center" data-id="element-122">
            <div className="text-3xl sm:text-4xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-green-500 to-green-700 mb-1 sm:mb-2" data-id="element-123">
              {adventureStats.totalWalks}
            </div>
            <div className="text-xs sm:text-sm font-medium text-gray-600 bg-green-100 rounded-full px-2.5 py-1 sm:px-3 sm:py-1 inline-block" data-id="element-124">
              Total Walks
            </div>
          </div>
          <div className="text-center" data-id="element-125">
            <div className="text-3xl sm:text-4xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-green-500 to-green-700 mb-1 sm:mb-2" data-id="element-126">
              {adventureStats.totalDistance}
            </div>
            <div className="text-xs sm:text-sm font-medium text-gray-600 bg-green-100 rounded-full px-2.5 py-1 sm:px-3 sm:py-1 inline-block" data-id="element-127">
              Miles Walked
            </div>
          </div>
          <div className="text-center" data-id="element-128">
            <div className="text-3xl sm:text-4xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-green-500 to-green-700 mb-1 sm:mb-2" data-id="element-129">
              {adventureStats.mostActiveMonth}
            </div>
            <div className="text-xs sm:text-sm font-medium text-gray-600 bg-green-100 rounded-full px-2.5 py-1 sm:px-3 sm:py-1 inline-block" data-id="element-130">
              Most Active Month
            </div>
          </div>
        </div>
        <div className="mt-4 sm:mt-6 pt-4 sm:pt-6 border-t border-green-100 flex flex-col sm:flex-row gap-3 sm:gap-0 sm:justify-between sm:items-center" data-id="element-131">
          <div className="flex items-center" data-id="element-132">
            <div className="bg-green-100 p-1.5 sm:p-2 rounded-full mr-2 sm:mr-3 flex-shrink-0" data-id="element-133">
              <MapPinIcon className="w-4 h-4 sm:w-5 sm:h-5 text-green-600" data-id="element-134" />
            </div>
            <span className="text-gray-700 font-medium text-sm sm:text-base" data-id="element-135">
              Favorite spot: {adventureStats.favoriteLocation}
            </span>
          </div>
          <div className="flex items-center" data-id="element-136">
            <div className="bg-green-100 p-1.5 sm:p-2 rounded-full mr-2 sm:mr-3 flex-shrink-0" data-id="element-137">
              <CalendarIcon className="w-4 h-4 sm:w-5 sm:h-5 text-green-600" data-id="element-138" />
            </div>
            <span className="text-gray-700 font-medium text-sm sm:text-base" data-id="element-139">
              Longest walk: {adventureStats.longestWalk}
            </span>
          </div>
        </div>
      </div>
      {/* Memorable Adventures */}
      <h3 className="font-semibold text-gray-800 text-lg sm:text-xl mb-4 sm:mb-6 flex items-center" data-id="element-140">
        <MapIcon className="w-4 h-4 sm:w-5 sm:h-5 text-green-600 mr-2 flex-shrink-0" data-id="element-141" />
        Memorable Adventures
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-id="element-142">
        {memorableWalks.map(walk => <div key={walk.id} className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 group flex flex-col h-full" data-id="element-143">
            <div className="h-32 sm:h-40 overflow-hidden" data-id="element-144">
              <img src={walk.image} alt={walk.location} className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500" data-id="element-145" />
            </div>
            <div className="p-3 sm:p-4 flex flex-col flex-1" data-id="element-146">
              <div className="flex justify-between items-center mb-1 sm:mb-2" data-id="element-147">
                <h4 className="font-semibold text-gray-800 text-sm sm:text-base" data-id="element-148">
                  {walk.location}
                </h4>
                <span className="text-xs bg-green-100 text-green-700 px-2.5 py-1 sm:px-3 sm:py-1 rounded-full font-medium flex-shrink-0" data-id="element-149">
                  {walk.date}
                </span>
              </div>
              <p className="text-gray-600 text-xs sm:text-sm mt-auto" data-id="element-150">
                {walk.highlight}
              </p>
            </div>
          </div>)}
      </div>
      <div className="mt-8 sm:mt-10 bg-gradient-to-r from-green-500 to-green-600 rounded-xl p-4 sm:p-5 text-center shadow-md" data-id="element-151">
        <span className="text-white font-semibold text-base sm:text-lg" data-id="element-152">
          You and {petName} walked the equivalent of 12 marathons this year!
        </span>
      </div>
    </section>;
};